export default "__VITE_ASSET__4179942d__"